import React from "react";
import "../../Css/HomePage/HomeCommitment.css";
import commitment01 from "../../Images/tena.jpg";
import commitment02 from "../../Images/sixteena.jpg";
import icons01 from "../../Images/Commitment/icon01.png";
import icons02 from "../../Images/Commitment/icon02.png";
import icons03 from "../../Images/Commitment/icon03.png";
import icons04 from "../../Images/Commitment/icon04.png";
import { Slide } from "react-awesome-reveal";

const HomeCommitment = (() => {
    return (
        <>
            <section className="home-commitment-section mb-5 pb-5">
                <div className="container">
                    <div className="home-section-commitment-main-con">
                        <div className="row">
                            <div className="col-md-6">
                                <Slide>
                                <div className="home-section-commitment-images-main-con">
                                    <div className="home-section-commitment-image-first-main-con">
                                        <img src={commitment01} alt="commitment" />
                                    </div>
                                    <div className="home-section-commitment-image-second-main-con">
                                        <div className="home-section-commitment-details-second-main-con">
                                            <h2>10</h2>
                                            <h3>YEARS</h3>
                                        </div>
                                        <div className="home-section-commitment-details-second-main-con">
                                            <h2>07</h2>
                                            <h3>TYPES</h3>
                                        </div>
                                        <div className="home-section-commitment-details-second-main-con">
                                            <h2>30</h2>
                                            <h3>ROOMS</h3>
                                        </div>
                                        <div className="home-section-commitment-details-second-main-con">
                                            <h2>55</h2>
                                            <h3>STAFF</h3>
                                        </div>
                                    </div>
                                    <div className="home-section-commitment-image-third-main-con">
                                        <img src={commitment02} alt="commitment" />
                                    </div>

                                </div>
                                </Slide>
                            </div>
                            <div className="col-md-6">
                                <Slide direction="right">
                                <div className="home-section-commitment-details-main-con-info">
                                    <div className="home-section-commitment-details-main-info">
                                        <h4 className="mt-2" style={{color:"#ece2b1"}}>OUR COMMITMENT</h4>
                                        {/* <h5>Custom Services</h5> */}
                                        <p style={{textAlign:'justify',color:"#ece2b1"}}>In addition to offering a cosy stay, Seema Resort is a popular destination for those who enjoy nature and adventure. It is the perfect place for outdoor enthusiasts because of the many walking paths, beautiful vistas, and tumbling waterfalls found in the surrounding hills. A short distance away is the well-known Neral-Matheran Toy Train journey for people who wish to do more exploring. We provide a range of activities within the resort to enhance your stay, such as leisure pursuits, birdwatching, and nature hikes.                                        </p>
                                        {/* <p style={{textAlign:'justify',color:"#ece2b1"}}>With a variety of regional and international meals prepared with fresh ingredients, our dining selections at Seema Resort are sure to please any pallet. Our cosy, welcoming atmosphere guarantees a great dinner, whether you're dining with family or friends. Seema Resort is the ideal option if you're looking for a tranquil yet exciting vacation. Experience the finest of comfort and nature at our resort in Neral by making your reservation today. Our goal is to make your visit one to remember!                                        </p> */}
                                    </div>
                                </div>
                                </Slide>
                            </div>
                        </div>
                        {/* <div className="home-section-commitment-details-other-main-con">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="home-section-commitment-details-other-image-text-con">
                                        <div className="home-section-commitment-details-other-image-con">
                                            <img src={icons01} alt="icons01" />
                                        </div>
                                        <div className="home-section-commitment-details-other-info-text-con">
                                            <h6>Transport</h6>
                                            <p>Parking Available</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="home-section-commitment-details-other-image-text-con">
                                        <div className="home-section-commitment-details-other-image-con">
                                            <img src={icons02} alt="icons01" />
                                        </div>
                                        <div className="home-section-commitment-details-other-info-text-con">
                                            <h6>Salt Pool</h6>
                                            <p>Swimming Pool</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="home-section-commitment-details-other-image-text-con">
                                        <div className="home-section-commitment-details-other-image-con">
                                            <img src={icons03} alt="icons01" />
                                        </div>
                                        <div className="home-section-commitment-details-other-info-text-con">
                                            <h6>King Rooms</h6>
                                            <p>King Size Beds</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="home-section-commitment-details-other-image-text-con">
                                        <div className="home-section-commitment-details-other-image-con">
                                            <img src={icons04} alt="icons01" />
                                        </div>
                                        <div className="home-section-commitment-details-other-info-text-con">
                                            <h6>Room Service</h6>
                                            <p>Attentive Room Service</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
        </>
    )
});

export default HomeCommitment;